import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'fastCover.step3.sectionTitle',
    defaultMessage: 'Section 10 - Bank Details',
  },
  whatIsYourABN: {
    id: 'fastCover.step3.whatIsYourABN',
    defaultMessage: 'What is your Australian Business Number (ABN)?',
  },
  claimITC: {
    id: 'fastCover.step3.claimITC',
    defaultMessage: 'Have you claimed or are you entitled to claim an Input Tax Credit (ITC) in respect to the GST paid on the insurance policy under which this claim is being made?',
  },
  whatPercentageOfGST: {
    id: 'fastCover.step3.whatPercentageOfGST',
    defaultMessage: 'What percentage of GST did you claim or are entitled to claim?',
  },
  yes: {
    id: 'fastCover.step3.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.step3.no',
    defaultMessage: 'No',
  },
  weCannotDepositIntoACreditCardAccount: {
    id: 'fastCover.step3.weCannotDepositIntoACreditCardAccount',
    defaultMessage: 'We cannot deposit into a credit card account or overseas bank account.',
  },
  paymentRequiredMessage: {
    id: 'fastCover.step3.paymentRequiredMessage',
    defaultMessage: 'If we are required to make a payment on your behalf, no payment will be made until we receive payment from you of any applicable excess.',
  },
  nameOfBank: {
    id: 'fastCover.step3.nameOfBank',
    defaultMessage: 'Name of Bank',
  },
  branch: {
    id: 'fastCover.step3.branch',
    defaultMessage: 'Branch Name',
  },
  bsbNumber: {
    id: 'fastCover.step3.bsbNumber',
    defaultMessage: 'Branch Code (BSB)',
  },
  accountNumber: {
    id: 'fastCover.step3.accountNumber',
    defaultMessage: 'Account Number',
  },
  accountHolder: {
    id: 'fastCover.step3.accountHolder',
    defaultMessage: 'Account Name',
  },
  GSTInfo: {
    id: 'fastCover.step3.GSTInfo',
    defaultMessage: 'GST information - applicable if your policy was purchased for a business',
  },
  areYouRegisteredForGTSPurposes: {
    id: 'fastCover.step3.areYouRegisteredForGTSPurposes',
    defaultMessage: 'Are you registered for GST Purposes?',
  },
  pleaseNote: {
    id: 'fastCover.step3.pleaseNote',
    defaultMessage: 'Please note',
  },
  depositMessage: {
    id: 'fastCover.step3.depositMessage',
    defaultMessage: 'If your claim is approved and where a cash settlement applies, we will deposit your settlement directly into your nominated bank account.',
  },
  bsbNumberLengthValidation: {
    id: 'fastCover.step3.bsbNumberLengthValidation',
    defaultMessage: 'BSB Number is 6 digits only.',
  },
  bsbCannotBeVerified: {
    id: 'fastCover.step3.bsbCannotBeVerified',
    defaultMessage: 'BSB number cannot be verified',
  },
  notice: {
    id: 'fastCover.step3.notice',
    defaultMessage: 'The BSB Number you have entered could not be verified.',
  },
  noticeIntruction: {
    id: 'fastCover.step3.noticeIntruction',
    defaultMessage: 'To continue any way, please tick the checkbox and manually enter the remaining fields.',
  },
  invalidBSBWarning: {
    id: 'fastCover.step3.invalidBSBWarning',
    defaultMessage: 'The entered BSB number is not found in our records, tick the checkbox in order to successfully submit the claim.',
  },
  doYouHaveAnotherOtherInsurance: {
    id: 'fastCover.step3.doYouHaveAnotherOtherInsurance',
    defaultMessage:
      'Do you have any other insurance that would cover all or part of your loss?',
  },
  exampleHomeContentsInsurance: {
    id: 'fastCover.step3.exampleHomeContentsInsurance',
    defaultMessage:
      'e.g. Home Contents insurance, Private Health Fund, Credit Card',
  },
  ifYesPleaseProvideDetails: {
    id: 'fastCover.step3.ifYesPleaseProvideDetails',
    defaultMessage: 'If yes, please provide details',
  },
  isRequired: {
    id: 'fastCover.step3.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step3/messages.js